import { products, isProductSupported } from './supportedProducts';

export const searchType = {
    Flight: 1,
    Hotels: 2,
    Holidays: 3,
    Transfers: 4,
    CarHire: 5,
    Parking: 6,
    Insurance: 8
};

export function supportedTypes() {
    return isProductSupported(products.holidays) ? [searchType.Flight, searchType.Holidays, searchType.Hotels, searchType.Transfers, searchType.Parking, searchType.Insurance] : [searchType.Hotels];
}
